import { render, staticRenderFns } from "./HTMLTextForm.vue?vue&type=template&id=597e89b5"
import script from "./HTMLTextForm.vue?vue&type=script&lang=js"
export * from "./HTMLTextForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports